import { useSearchParams } from 'react-router'
import type { ChartType } from '../api/types'
import type { ChartSelection } from '../components/charts/ChartPickers'
import { ROOT_GENRE } from './useMeta'

/** Chart selection stored in the URL (?p=&c=&g=&t=) so views are linkable. */
export function useChartSelection(): [ChartSelection, (next: ChartSelection) => void, URLSearchParams] {
	const [params, setParams] = useSearchParams()
	const platform = params.get('p') ?? 'iphone'
	const selection: ChartSelection = {
		platform,
		storefront: params.get('c') ?? 'us',
		genre: Number(params.get('g') ?? ROOT_GENRE[platform] ?? 36),
		type: (params.get('t') as ChartType) ?? 'free',
	}
	function update(next: ChartSelection) {
		const genre =
			next.platform !== selection.platform && ROOT_GENRE[next.platform] !== ROOT_GENRE[selection.platform]
				? ROOT_GENRE[next.platform]
				: next.genre
		const out = new URLSearchParams(params)
		out.set('p', next.platform)
		out.set('c', next.storefront)
		out.set('g', String(genre))
		out.set('t', next.type)
		out.delete('at')
		setParams(out, { replace: true })
	}
	return [selection, update, params]
}
